/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type {TypedDocumentNode as DocumentNode} from '@graphql-typed-document-node/core'

export type Avatar =
    | 'Aquamarine'
    | 'Arctic'
    | 'Azure'
    | 'Emerald'
    | 'Indigo'
    | 'Mint'
    | 'Neon'
    | 'Ocean'
    | 'Sapphire'
    | 'Sky'
    | 'Turquoise'
    | 'Vivid';

export type League =
    | 'Bronze'
    | 'Diamond'
    | 'Expert'
    | 'Feathered'
    | 'Gold'
    | 'Junior'
    | 'Master'
    | 'Nestling'
    | 'Platinum'
    | 'Plus'
    | 'Premium'
    | 'Pro'
    | 'Silver';

export type PaginationInput = {
    limit?: number | null | undefined;
    offset?: number | null | undefined;
};

export type TransactionInput = {
    amount: number;
    idempotencyKey: string;
    wallet?: string | null | undefined;
};

export type TransactionType =
    | 'burn'
    | 'credit'
    | 'debit'
    | 'mint';

export type AuthMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthMutation = { auth: string };

export type SetAvatarMutationVariables = Exact<{
    avatar: Avatar;
}>;


export type SetAvatarMutation = { setAvatar: boolean };

export type TransferMutationVariables = Exact<{
    transaction: TransactionInput;
}>;


export type TransferMutation = {
    transfer: {
        uuid: string,
        amount: number,
        timestamp: unknown,
        sender: {
            uuid: string,
            bird: {
                uuid: string,
                username: string,
                firstName: string,
                lastName: string | null,
                premium: boolean,
                avatar: Avatar | null,
                league: League
            } | null
        } | null,
        recipient: {
            uuid: string,
            bird: {
                uuid: string,
                username: string,
                firstName: string,
                lastName: string | null,
                premium: boolean,
                avatar: Avatar | null,
                league: League
            } | null
        } | null
    }
};

export type NeedOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type NeedOnboardingQuery = { me: { avatar: Avatar | null } };

export type MeQueryVariables = Exact<{
    pagination?: PaginationInput | null | undefined;
}>;


export type MeQuery = {
    me: {
        uuid: string,
        username: string,
        firstName: string,
        lastName: string | null,
        premium: boolean,
        language: string | null,
        avatar: Avatar | null,
        league: League,
        wallet: {
            uuid: string,
            balance: number,
            transactions: Array<{
                uuid: string,
                txType: TransactionType,
                wallet: string | null,
                birdUuid: string | null,
                bird: string | null,
                amount: number,
                comment: string | null,
                timestamp: unknown
            }>
        },
        goals: Array<{ name: string, description: string | null }>
    }
};

export type BirdQueryVariables = Exact<{
    uuid: string;
}>;


export type BirdQuery = {
    bird: {
        uuid: string,
        username: string,
        firstName: string,
        lastName: string | null,
        premium: boolean,
        avatar: Avatar | null,
        league: League
    } | null
};

export type BirdsQueryVariables = Exact<{
    uuid?: string | null | undefined;
    league?: League | null | undefined;
    pagination?: PaginationInput | null | undefined;
}>;


export type BirdsQuery = {
    birds: Array<{
        uuid: string,
        username: string,
        firstName: string,
        lastName: string | null,
        premium: boolean,
        avatar: Avatar | null,
        league: League,
        wallet: { balance: number }
    }>
};

export type WalletQueryVariables = Exact<{
    uuid: string;
}>;


export type WalletQuery = {
    wallet: {
        uuid: string,
        balance: number,
        bird: {
            uuid: string,
            username: string,
            firstName: string,
            lastName: string | null,
            premium: boolean,
            avatar: Avatar | null,
            league: League
        } | null
    } | null
};

export type WalletsQueryVariables = Exact<{
    uuid?: string | null | undefined;
    pagination?: PaginationInput | null | undefined;
}>;


export type WalletsQuery = {
    wallets: Array<{
        uuid: string,
        balance: number,
        bird: {
            uuid: string,
            username: string,
            firstName: string,
            lastName: string | null,
            premium: boolean,
            avatar: Avatar | null,
            league: League
        } | null
    }>
};

export type TransactionQueryVariables = Exact<{
    uuid: string;
}>;


export type TransactionQuery = {
    transaction: {
        uuid: string,
        amount: number,
        comment: string | null,
        timestamp: unknown,
        sender: {
            uuid: string,
            bird: {
                uuid: string,
                username: string,
                firstName: string,
                lastName: string | null,
                premium: boolean,
                avatar: Avatar | null,
                league: League
            } | null
        } | null,
        recipient: {
            uuid: string,
            bird: {
                uuid: string,
                username: string,
                firstName: string,
                lastName: string | null,
                premium: boolean,
                avatar: Avatar | null,
                league: League
            } | null
        } | null
    } | null
};

export type TransactionsQueryVariables = Exact<{
    uuid?: string | null | undefined;
    pagination?: PaginationInput | null | undefined;
}>;


export type TransactionsQuery = {
    transactions: Array<{
        uuid: string,
        amount: number,
        comment: string | null,
        timestamp: unknown,
        sender: {
            uuid: string,
            bird: {
                uuid: string,
                username: string,
                firstName: string,
                lastName: string | null,
                premium: boolean,
                avatar: Avatar | null,
                league: League
            } | null
        } | null,
        recipient: {
            uuid: string,
            bird: {
                uuid: string,
                username: string,
                firstName: string,
                lastName: string | null,
                premium: boolean,
                avatar: Avatar | null,
                league: League
            } | null
        } | null
    }>
};

export type GoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsQuery = { goals: Array<{ name: string, description: string | null, discoveredAt: unknown }> };


export const AuthDocument = {
    'kind': 'Document',
    'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'mutation',
        'name': {'kind': 'Name', 'value': 'Auth'},
        'selectionSet': {'kind': 'SelectionSet', 'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'auth'}}]}
    }]
} as unknown as DocumentNode<AuthMutation, AuthMutationVariables>
export const SetAvatarDocument = {
    'kind': 'Document',
    'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'mutation',
        'name': {'kind': 'Name', 'value': 'SetAvatar'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'avatar'}},
            'type': {'kind': 'NonNullType', 'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'Avatar'}}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet',
            'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'setAvatar'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'avatar'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'avatar'}}
                }]
            }]
        }
    }]
} as unknown as DocumentNode<SetAvatarMutation, SetAvatarMutationVariables>
export const TransferDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'mutation',
        'name': {'kind': 'Name', 'value': 'Transfer'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'transaction'}},
            'type': {'kind': 'NonNullType', 'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'TransactionInput'}}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet', 'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'transfer'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'transaction'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'transaction'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'amount'}
                    }, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'sender'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'bird'},
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'username'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'lastName'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'avatar'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                                }
                            }]
                        }
                    }, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'recipient'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'bird'},
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'username'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'lastName'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'avatar'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                                }
                            }]
                        }
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'timestamp'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<TransferMutation, TransferMutationVariables>
export const NeedOnboardingDocument = {
    'kind': 'Document',
    'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'NeedOnboarding'},
        'selectionSet': {
            'kind': 'SelectionSet',
            'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'me'},
                'selectionSet': {'kind': 'SelectionSet', 'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'avatar'}}]}
            }]
        }
    }]
} as unknown as DocumentNode<NeedOnboardingQuery, NeedOnboardingQueryVariables>
export const MeDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Me'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'PaginationInput'}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet', 'selections': [{
                'kind': 'Field', 'name': {'kind': 'Name', 'value': 'me'}, 'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'username'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'lastName'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'language'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'avatar'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'league'}
                    }, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'wallet'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'balance'}
                            }, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'transactions'},
                                'arguments': [{
                                    'kind': 'Argument',
                                    'name': {'kind': 'Name', 'value': 'pagination'},
                                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}}
                                }],
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'txType'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'wallet'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'birdUuid'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'bird'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'amount'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'comment'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'timestamp'}
                                    }]
                                }
                            }]
                        }
                    }, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'goals'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'name'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'description'}
                            }]
                        }
                    }]
                }
            }]
        }
    }]
} as unknown as DocumentNode<MeQuery, MeQueryVariables>
export const BirdDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Bird'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}},
            'type': {'kind': 'NonNullType', 'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'String'}}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet',
            'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'bird'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'uuid'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'username'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'lastName'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'avatar'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<BirdQuery, BirdQueryVariables>
export const BirdsDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Birds'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'String'}}
        }, {
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'league'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'League'}}
        }, {
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'PaginationInput'}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet', 'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'birds'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'uuid'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}}
                }, {
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'league'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'league'}}
                }, {
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'pagination'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'username'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'lastName'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'avatar'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'wallet'},
                        'selectionSet': {'kind': 'SelectionSet', 'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'balance'}}]}
                    }]
                }
            }]
        }
    }]
} as unknown as DocumentNode<BirdsQuery, BirdsQueryVariables>
export const WalletDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Wallet'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}},
            'type': {'kind': 'NonNullType', 'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'String'}}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet',
            'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'wallet'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'uuid'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'bird'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'username'}
                            }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'lastName'}
                            }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'avatar'}
                            }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                        }
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'balance'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<WalletQuery, WalletQueryVariables>
export const WalletsDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Wallets'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'String'}}
        }, {
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'PaginationInput'}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet', 'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'wallets'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'uuid'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}}
                }, {
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'pagination'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'bird'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'username'}
                            }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'lastName'}
                            }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'avatar'}
                            }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                        }
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'balance'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<WalletsQuery, WalletsQueryVariables>
export const TransactionDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Transaction'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}},
            'type': {'kind': 'NonNullType', 'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'String'}}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet', 'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'transaction'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'uuid'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'sender'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'bird'},
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'username'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'lastName'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'avatar'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                                }
                            }]
                        }
                    }, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'recipient'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'bird'},
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'username'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'lastName'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'avatar'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                                }
                            }]
                        }
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'amount'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'comment'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'timestamp'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<TransactionQuery, TransactionQueryVariables>
export const TransactionsDocument = {
    'kind': 'Document', 'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Transactions'},
        'variableDefinitions': [{
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'String'}}
        }, {
            'kind': 'VariableDefinition',
            'variable': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}},
            'type': {'kind': 'NamedType', 'name': {'kind': 'Name', 'value': 'PaginationInput'}}
        }],
        'selectionSet': {
            'kind': 'SelectionSet', 'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'transactions'},
                'arguments': [{
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'uuid'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'uuid'}}
                }, {
                    'kind': 'Argument',
                    'name': {'kind': 'Name', 'value': 'pagination'},
                    'value': {'kind': 'Variable', 'name': {'kind': 'Name', 'value': 'pagination'}}
                }],
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'sender'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'bird'},
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'username'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'lastName'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'avatar'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                                }
                            }]
                        }
                    }, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'recipient'},
                        'selectionSet': {
                            'kind': 'SelectionSet',
                            'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                'kind': 'Field',
                                'name': {'kind': 'Name', 'value': 'bird'},
                                'selectionSet': {
                                    'kind': 'SelectionSet',
                                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'uuid'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'username'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'firstName'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'lastName'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'premium'}}, {
                                        'kind': 'Field',
                                        'name': {'kind': 'Name', 'value': 'avatar'}
                                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'league'}}]
                                }
                            }]
                        }
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'amount'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'comment'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'timestamp'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<TransactionsQuery, TransactionsQueryVariables>
export const GoalsDocument = {
    'kind': 'Document',
    'definitions': [{
        'kind': 'OperationDefinition',
        'operation': 'query',
        'name': {'kind': 'Name', 'value': 'Goals'},
        'selectionSet': {
            'kind': 'SelectionSet',
            'selections': [{
                'kind': 'Field',
                'name': {'kind': 'Name', 'value': 'goals'},
                'selectionSet': {
                    'kind': 'SelectionSet',
                    'selections': [{'kind': 'Field', 'name': {'kind': 'Name', 'value': 'name'}}, {
                        'kind': 'Field',
                        'name': {'kind': 'Name', 'value': 'description'}
                    }, {'kind': 'Field', 'name': {'kind': 'Name', 'value': 'discoveredAt'}}]
                }
            }]
        }
    }]
} as unknown as DocumentNode<GoalsQuery, GoalsQueryVariables>
